import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useState, useMemo, useCallback } from 'react';
import classnames from 'classnames';
import { Tooltip } from '@grandvisionhq/common';
import { FormContext } from '../Form/Form.js';
import { FormControl } from '../FormControl/FormControl.js';
import Select from '../Select/Select.js';

const PrefixSelect = ({ errorMessage , label , tooltipLabel , placeholder ='Prefix' , onChange , options , initialState , required =false , hideAsteriskSign =false , name ='salutation' ,  })=>{
    const [value, setValue] = useState(initialState && initialState.value || '');
    const [isTouched, setIsTouched] = useState(initialState && initialState.isTouched || false);
    const isValid = useMemo(()=>FormControl.validate([], required, value)
    , [
        value,
        required
    ]);
    const readonly = initialState && initialState.readonly;
    React.useEffect(()=>{
        onChange && onChange(swcHelpers.objectSpread({
            value,
            name,
            isValid,
            isTouched
        }, readonly === undefined ? {} : {
            readonly
        }));
    }, [
        onChange,
        value,
        name,
        isValid,
        isTouched
    ]);
    React.useEffect(()=>{
        setValue((initialState === null || initialState === void 0 ? void 0 : initialState.value) || '');
        setIsTouched((initialState === null || initialState === void 0 ? void 0 : initialState.isTouched) || false);
    }, [
        initialState === null || initialState === void 0 ? void 0 : initialState.value,
        initialState === null || initialState === void 0 ? void 0 : initialState.isTouched
    ]);
    const handleChange = useCallback((option)=>{
        setValue(option.label);
        setIsTouched(true);
    }, [
        required
    ]);
    const classes = classnames('prefix-select__input', {
        _is_valid: isValid && isTouched && !readonly,
        _is_invalid: !isValid && isTouched && !readonly
    });
    return /*#__PURE__*/ React.createElement("label", {
        className: "form-control prefix-select"
    }, label && /*#__PURE__*/ React.createElement("div", {
        className: "form-control__label"
    }, label, required && !hideAsteriskSign && /*#__PURE__*/ React.createElement("span", {
        className: "form-control__asterisk"
    }, "*"), tooltipLabel && /*#__PURE__*/ React.createElement(Tooltip, {
        id: `${name}-tooltip`,
        message: tooltipLabel
    })), /*#__PURE__*/ React.createElement("div", {
        className: "form-control__wrapper"
    }, /*#__PURE__*/ React.createElement(Select, {
        className: classes,
        id: "salutation",
        name: "salutation",
        placeholder: placeholder,
        options: options,
        initialState: {
            value,
            isTouched,
            isValid
        },
        onChange: handleChange,
        disabled: readonly,
        "aria-invalid": !isValid,
        "aria-labelledby": "prefix-select"
    })), !isValid && isTouched && /*#__PURE__*/ React.createElement("span", {
        className: "form-control__error"
    }, errorMessage));
};
const ConnectedPrefixSelect = (props)=>/*#__PURE__*/ React.createElement(FormContext.Consumer, null, (context = {})=>/*#__PURE__*/ React.createElement(PrefixSelect, swcHelpers.extends({}, props, {
            onChange: context.onChange,
            initialState: context.getInitialState && context.getInitialState(props.name || 'salutation') || props.initialState
        }))
    )
;
ConnectedPrefixSelect.defaultProps = swcHelpers.objectSpread({}, PrefixSelect.defaultProps);
var ConnectedPrefixSelect$1 = ConnectedPrefixSelect;

export { PrefixSelect, ConnectedPrefixSelect$1 as default };
//# sourceMappingURL=PrefixSelect.js.map
